import React, { useState } from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';

import FieldCcusApi from '../services/FieldCcus';
import SessionStorageService from '../services/utilities/SessionStorageService';
import IchiPlusLinkageSettingService from '../services/IchiPlusLinkageSetting';
import { jvCompanyList } from '../services/FieldTree';

import { MasterPageHeader } from '../components/PageHeader';
import {
  FormList,
  FormListItem,
  FormListSubHeader,
} from '../components/CommonFormComponents';
import { CloseEditView } from '../components/CloseEditView';
import { FieldNaviList } from '../components/list/FieldNaviList';
import {
  renderToolTip,
  VerticalScrollBodyTable,
} from '../components/tables/VerticalScrollBodyTable';
import { FormInformationDialog } from '../components/FormInformationDialog';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import MultiSelectDropdownSaveOnClose from '../components/dropdowns/MultiSelectDropdownSaveOnClose';
import { Description } from '../components/Description';

import {
  API_FLAG,
  FIELD_NAVI_LIST,
  HEADER_CONSTANTS,
  PAGE_REFERER,
  REQUEST_PARAMS,
} from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import _dialogLoader from '../utilities/dialogLoader';
import {
  calcHeightTable,
  HEIGHT_ROW_TABLE,
} from '../utilities/IchiPlusLinkageSettingUtil';
import { isPrimeRoleId } from '../utilities/roleUtility';
import { messageUtility } from '../utilities/messageUtility';

/**
 * 位置プラス連携設定・編集
 * @props {number} view.state.id: fieldId
 */

export class IchiPlusLinkageSettingEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabledCooperationCcus: true,
      partnerCompaniesMainJV: [],
      totalPartnerCompaniesMainJV: 0,
      isLoadingPartnerCompaniesMainJV: true,
      partnerCompaniesSubJV: [],
      totalPartnerCompaniesSubJV: 0,
      isLoadingPartnerCompaniesSubJV: true,
      paramUpdate: {
        checked_field_tree_ids: [],
        unchecked_field_tree_ids: [],
      },
      beforePageReferer: SessionStorageService.getBeforePageName(),
      hasSubJV: false,
      isLoading: true,
    };

    if (props.view) {
      this.fieldId = props.view.state.id;
    } else if (props.match) {
      this.fieldId = props.match.params.id;
    }

    this.events = {
      table: {
        changeCheckBox: this.changeCheckBox,
        handleSelectorChange: this.handleSelectorChange,
      },
    };

    this.GoBack = {
      callback: {
        close: () => {
          _dialogLoader.close();
        },
        clear: () => {
          _masterSlideLoader.show('IchiPlusLinkageSettingDetail', {
            state: { id: this.fieldId },
          });
          _dialogLoader.close();
        },
      },
    };

    this.companyId = Number(SessionStorageService.getCompanyId());
    this.companyBranchId = Number(SessionStorageService.getCompanyBranchId());
    this.viewBodyRef = React.createRef();
    this.isUpdatingFlag = false;
  }

  async componentDidMount() {
    await this.checkUserMainJv();
    this.onLoadPermissionFieldTreeCooperation();
    this.onLoadPartnerCompanies();
    window.addEventListener('resize', this.resizeHeightTable);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHeightTable);
  }

  checkUserMainJv = () => {
    const params = { offset: 0, limit: 2 };
    return jvCompanyList(this.fieldId, params).then(response => {
      if (response.result) {
        const jvList = _.get(response, 'data.entities.company');
        const mainJv = jvList[0];
        const hasSubJV = _.size(jvList) > 1;
        let isUserMainJV;
        if (isPrimeRoleId()) {
          isUserMainJV = this.companyId === mainJv.company_id;
        } else {
          isUserMainJV = this.companyBranchId === mainJv.company_branch_id;
        }
        if (!isUserMainJV) {
          return window.location.replace('/error-permission');
        }
        const heightViewBody = this.viewBodyRef.current.offsetHeight;
        const heightTable = calcHeightTable(heightViewBody, hasSubJV);
        this.setState({ isUserMainJV, hasSubJV, heightTable });
      }
    });
  };

  onLoadPermissionFieldTreeCooperation = () => {
    FieldCcusApi.checkPermissionFieldTreeCooperationWithCcus(this.fieldId).then(
      response => {
        if (response.result) {
          this.setState({
            disabledCooperationCcus: !_.get(
              response,
              'data.entities.enable_ccus_flag'
            ),
          });
        }
      }
    );
  };

  resizeHeightTable = () => {
    const heightViewBody = this.viewBodyRef.current.offsetHeight;
    const heightTable = calcHeightTable(heightViewBody, this.state.hasSubJV);
    this.setState({ heightTable });
  };

  onLoadPartnerCompanies = () => {
    const params = { limit: REQUEST_PARAMS.parentLimit, offset: 0 };
    Promise.all([
      IchiPlusLinkageSettingService.fieldTreesIchiPlusList(this.fieldId, {
        ...params,
        main_flag: API_FLAG.On,
      }),
      this.state.hasSubJV &&
        IchiPlusLinkageSettingService.fieldTreesIchiPlusList(this.fieldId, {
          ...params,
          main_flag: API_FLAG.Off,
        }),
    ]).then(response => {
      const partnerCompaniesMainJV = _.get(
        response,
        '[0].data.entities.field_trees',
        []
      );
      const partnerCompaniesSubJV = _.get(
        response,
        '[1].data.entities.field_trees',
        []
      );
      if (
        _.isEmpty(partnerCompaniesMainJV) &&
        _.isEmpty(partnerCompaniesSubJV)
      ) {
        return window.location.replace('/error-permission');
      }
      this.setState({
        partnerCompaniesMainJV,
        totalPartnerCompaniesMainJV: _.get(response, '[0].data.total', 0),
        partnerCompaniesSubJV,
        totalPartnerCompaniesSubJV: _.get(response, '[1].data.total', 0),
        isLoadingPartnerCompaniesMainJV: false,
        isLoadingPartnerCompaniesSubJV: false,
        isLoading: false,
      });
    });
  };

  onLoadPartnerCompaniesMainJV = () => {
    let partnerCompaniesMainJV = _.cloneDeep(this.state.partnerCompaniesMainJV);
    if (
      !_.isEmpty(partnerCompaniesMainJV) &&
      _.size(partnerCompaniesMainJV) >= this.state.totalPartnerCompaniesMainJV
    ) {
      return;
    }
    this.setState({ isLoadingPartnerCompaniesMainJV: true }, () => {
      const params = {
        offset: _.size(partnerCompaniesMainJV),
        limit: REQUEST_PARAMS.parentLimit,
        main_flag: API_FLAG.On,
      };
      IchiPlusLinkageSettingService.fieldTreesIchiPlusList(
        this.fieldId,
        params
      ).then(response => {
        partnerCompaniesMainJV = partnerCompaniesMainJV.concat(
          _.get(response, 'data.entities.field_trees')
        );
        this.setState({
          partnerCompaniesMainJV,
          totalPartnerCompaniesMainJV: _.get(response, 'data.total'),
          isLoadingPartnerCompaniesMainJV: false,
        });
      });
    });
  };

  onLoadPartnerCompaniesSubJV = () => {
    let partnerCompaniesSubJV = _.cloneDeep(this.state.partnerCompaniesSubJV);
    if (
      !_.isEmpty(partnerCompaniesSubJV) &&
      _.size(partnerCompaniesSubJV) >= this.state.totalPartnerCompaniesSubJV
    ) {
      return;
    }
    this.setState({ isLoadingPartnerCompaniesSubJV: true }, () => {
      const params = {
        offset: _.size(partnerCompaniesSubJV),
        limit: REQUEST_PARAMS.parentLimit,
        main_flag: API_FLAG.Off,
      };
      IchiPlusLinkageSettingService.fieldTreesIchiPlusList(
        this.fieldId,
        params
      ).then(response => {
        partnerCompaniesSubJV = partnerCompaniesSubJV.concat(
          _.get(response, 'data.entities.field_trees')
        );
        this.setState({
          partnerCompaniesSubJV,
          totalPartnerCompaniesSubJV: _.get(response, 'data.total'),
          isLoadingPartnerCompaniesSubJV: false,
        });
      });
    });
  };

  handleUpdate = () => {
    if (this.isUpdatingFlag) {
      return;
    }
    this.isUpdatingFlag = true;
    IchiPlusLinkageSettingService.updateIchiPlusLinkage(
      this.fieldId,
      this.state.paramUpdate
    )
      .then(response => {
        if (response.result) {
          _dialogLoader.show(FormInformationDialog, {
            title: messageUtility.getMessage('I-000-204'),
            message: messageUtility.getMessage('I-000-205'),
            onClose: () => {
              this.GoBack.callback.clear();
            },
          });
        } else {
          _dialogLoader.show(FormInformationDialog, {
            title: messageUtility.getMessage('E-000-069'),
            message: messageUtility.getMessage('E-000-070'),
            onClose: () => {
              window.location.reload();
            },
          });
        }
      })
      .finally(() => {
        this.isUpdatingFlag = false;
      });
  };

  changeCheckBox = (id, checked) => {
    let paramUpdate = _.cloneDeep(this.state.paramUpdate);
    if (checked) {
      paramUpdate.checked_field_tree_ids.push(id);
      _.pull(paramUpdate.unchecked_field_tree_ids, id);
    } else {
      paramUpdate.unchecked_field_tree_ids.push(id);
      _.pull(paramUpdate.checked_field_tree_ids, id);
    }
    this.setState({ paramUpdate });
  };

  handleSelectorChange = (value, checked) => {
    let paramUpdate = _.cloneDeep(this.state.paramUpdate);
    if (checked) {
      paramUpdate.checked_field_tree_ids = _.union(
        paramUpdate.checked_field_tree_ids,
        value
      );
      _.pullAll(paramUpdate.unchecked_field_tree_ids, value);
    } else {
      paramUpdate.unchecked_field_tree_ids = _.union(
        paramUpdate.unchecked_field_tree_ids,
        value
      );
      _.pullAll(paramUpdate.checked_field_tree_ids, value);
    }
    this.setState({ paramUpdate });
  };

  openCloseEditModal = () => {
    _dialogLoader.show(CloseEditView, this.GoBack);
  };

  renderPartnerCompanyMainJVTable = () => {
    const {
      partnerCompaniesMainJV,
      heightTable,
      hasSubJV,
      totalPartnerCompaniesMainJV,
      isLoadingPartnerCompaniesMainJV,
    } = this.state;
    return (
      <React.Fragment>
        {hasSubJV && <FormListItem isBorder={false}>自社</FormListItem>}
        <FormListItem isBorder={false}>
          <TablePartnerCompany
            partnerCompanies={partnerCompaniesMainJV}
            minHeight={heightTable}
            maxHeight={heightTable}
            maxWidth={960}
            callbacks={this.events}
            total={totalPartnerCompaniesMainJV}
            loadItems={this.onLoadPartnerCompaniesMainJV}
            isLoading={isLoadingPartnerCompaniesMainJV}
          />
        </FormListItem>
      </React.Fragment>
    );
  };

  renderPartnerCompanySubJVTable = () => {
    const {
      partnerCompaniesSubJV,
      heightTable,
      hasSubJV,
      totalPartnerCompaniesSubJV,
      isLoadingPartnerCompaniesSubJV,
    } = this.state;
    if (hasSubJV) {
      return (
        <React.Fragment>
          <FormListItem isBorder={false}>JV構成会社</FormListItem>
          <FormListItem isBorder={false}>
            <TablePartnerCompany
              partnerCompanies={partnerCompaniesSubJV}
              minHeight={heightTable}
              maxHeight={heightTable}
              maxWidth={960}
              callbacks={this.events}
              isMainJV={false}
              total={totalPartnerCompaniesSubJV}
              loadItems={this.onLoadPartnerCompaniesSubJV}
              isLoading={isLoadingPartnerCompaniesSubJV}
            />
          </FormListItem>
        </React.Fragment>
      );
    }
  };

  render() {
    const {
      checked_field_tree_ids,
      unchecked_field_tree_ids,
    } = this.state.paramUpdate;
    const isDisabledUpdate =
      _.isEmpty(checked_field_tree_ids) && _.isEmpty(unchecked_field_tree_ids);
    return (
      <div
        id='slide-view'
        className='contruction-slide-view show IchiPlusLinkageSettingEdit'
      >
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 現場詳細・編集</title>
        </Helmet>

        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title='現場編集'
            onClose={this.openCloseEditModal}
          />

          <div
            className='contruction-slide-view__body contruction-slide-view__body--height-fix'
            ref={this.viewBodyRef}
          >
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <FieldNaviList
                  fieldId={this.fieldId}
                  selectedTab={
                    FIELD_NAVI_LIST.ICHI_PLUS_LINKAGE_DETAIL.TAB_NAME
                  }
                  disabledCooperationCcus={this.state.disabledCooperationCcus}
                  showJvSettingTab={
                    this.state.beforePageReferer === PAGE_REFERER.fields.key
                  }
                  isEditable={true}
                />
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <div className='contruction-detail-view__header'>
                  <button
                    className='btn-text--sm'
                    onClick={this.openCloseEditModal}
                  >
                    <i className='i-back--blue i-2x vertical-middle' />
                    {messageUtility.getMessage('I-000-208')}
                  </button>
                </div>
                <div className='contruction-detail-view__menu'>
                  <span className='construction-detail-view__button'>
                    <button
                      className='btn--sub'
                      onClick={this.openCloseEditModal}
                    >
                      {messageUtility.getMessage('I-000-209')}
                    </button>
                  </span>
                  <span className='construction-detail-view__button'>
                    <button
                      className={
                        isDisabledUpdate ? 'btn--disabled' : 'btn--effective'
                      }
                      disabled={isDisabledUpdate}
                      onClick={this.handleUpdate}
                    >
                      {messageUtility.getMessage('I-000-088')}
                    </button>
                  </span>
                </div>
                <div className='contruction-detail-view__bar' />
                <div className='contruction-detail-view__main contruction-detail-view__main--fixed'>
                  <FormList>
                    <FormListSubHeader
                      title='協力会社連携設定'
                      noMarginTop={true}
                    />
                    <FormListItem isBorder={false}>
                      <Description type='primary'>
                        {messageUtility.getMessage('I-000-202')}
                      </Description>
                    </FormListItem>
                    {this.state.isLoading ? (
                      <FormListItem isBorder={false}>
                        <div className='indicator' />
                      </FormListItem>
                    ) : (
                      <React.Fragment>
                        {this.renderPartnerCompanyMainJVTable()}
                        {this.renderPartnerCompanySubJVTable()}
                      </React.Fragment>
                    )}
                  </FormList>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/**
 *
 * @param {array} partnerCompanies: table data
 * @param {number} minHeight: min-height of table body
 * @param {number} maxHeight: max-height of table body
 * @param {number} maxWidth: max-width of table
 * @param {function} callbacks: handle events
 * @param {boolean} isLoading
 * @param {boolean} isMainJV: specify 自社 and JV構成会社 to display partner company name
 * @param {number} total: total records
 * @param {function} loadItems: callback for infinity scroll
 * @returns {JSX.Element}
 */
const TablePartnerCompany = ({
  partnerCompanies,
  minHeight,
  maxHeight,
  maxWidth,
  callbacks,
  isLoading,
  isMainJV = true,
  total,
  loadItems,
}) => {
  const [bodyId] = useState(_.uniqueId('infinity-scroll-target'));
  const headerColumns = [
    { id: 'checkbox', text: '', style: { width: 40 } },
    { id: 'company_name', text: '会社名' },
    { id: 'linkage', text: '', style: { width: 200 } },
    { id: 'job_names', text: '職種' },
  ];

  const bodyColumn = [
    {
      id: 'checkbox',
      render(data) {
        return (
          <label
            className={`checkbox ${
              data.deleted_flag ? 'multi-select__item-disabled' : ''
            }`}
            key={`checkbox-${data.id}`}
          >
            <input
              type='checkbox'
              name={`checkbox-${data.id}`}
              defaultChecked={
                data.ichiplus_partner_company_linkage_status.selecting_flag ||
                false
              }
              disabled={data.deleted_flag}
              onChange={event => {
                callbacks.table.changeCheckBox(data.id, event.target.checked);
              }}
              readOnly
            />
            <i className='i-square-checkbox i-2_5x' aria-hidden='true' />
          </label>
        );
      },
      style: { width: 40 },
    },
    {
      id: 'company_name',
      render: data => {
        const companyName = `${data.company_name}${
          data.company_branch_name ? ` ${data.company_branch_name}` : ''
        }`;
        if (isMainJV) {
          return renderToolTip(companyName);
        }
        return renderToolTip(`(${data.prime_contractor_name}) ${companyName}`);
      },
    },
    {
      id: 'linkage',
      render: data =>
        _.size(data.children) > 0 && (
          <MultiSelectDropdownSaveOnClose
            label='二次を追加'
            keyName='company_name_with_job'
            valueName='id'
            disableOptionName='deleted_flag'
            selected={_.map(
              _.filter(
                data.children,
                'ichiplus_partner_company_linkage_status.selecting_flag'
              ),
              'id'
            )}
            hasTooltipOnHeader={false}
            autoHideTooltipOnOption={false}
            apiSearchKey='name'
            api={async params => {
              if (params && params.name) {
                return _.filter(data.children, item =>
                  _.includes(item.company_name, params.name)
                );
              }
              return data.children;
            }}
            apiProcess={response => {
              return {
                data: response,
                total: response.length,
              };
            }}
            onSelect={(listSelected, value, checked) => {
              value && callbacks.table.handleSelectorChange(value, checked);
            }}
          />
        ),
      style: { width: 200 },
    },
    {
      id: 'job_names',
      className: 'value-table--job-name',
      render(data) {
        return <p className='value-table__txt--7'>{data.job_names}</p>;
      },
    },
  ];

  if (!total) {
    minHeight = HEIGHT_ROW_TABLE;
  }

  return (
    <VerticalScrollBodyTable
      headerColumns={headerColumns}
      bodyColumns={bodyColumn}
      data={partnerCompanies}
      bodyStyle={{ minHeight, maxHeight, maxWidth }}
      bodyId={bodyId}
      headerStyle={{ maxWidth }}
      allowEmptyData={false}
      bodyFooter={
        <tr className='infinity-scroll-load-item'>
          <td colSpan={4}>
            <InfinityScrollLoad
              total={total}
              targetId={bodyId}
              callback={loadItems}
              isLoading={isLoading}
              isScrollWithBody={true}
              ignoreIndicator={true}
            />
          </td>
        </tr>
      }
    />
  );
};



// WEBPACK FOOTER //
// ./src/pages/IchiPlusLinkageSettingEdit.jsx